import { useChain } from 'contexts';
import React from 'react';
import type { CardProps } from './types';

type Props = CardProps & {
  body: React.ReactNode;
  footer?: React.ReactNode;
};

const Card: React.FC<Props> = ({
  title,
  options,
  body,
  footer,
  filled = false,
  styleSlug: propStyleSlug,
  className,
  ...rest
}) => {
  const { styleSlug: backupStyleSlug } = useChain();
  const styleSlug = propStyleSlug || backupStyleSlug;
  const bgColor = filled
    ? `bg-${styleSlug}-dark bg-gradient-to-b dark:from-${styleSlug}-dark dark:to-gray-111 dark:box-shadow-inset`
    : 'bg-white dark:bg-gray-111';
  const titleColor = filled
    ? `text-${styleSlug}-light`
    : `text-${styleSlug}-primary dark:text-${styleSlug}-light`;
  const textColor = filled
    ? `text-${styleSlug}-light`
    : `text-gray-999 dark:text-${styleSlug}-light`;
  const bodyColor = filled ? 'text-white' : 'text-gray-444 dark:text-white';
  const hasHeader = !!title || !!options;
  return (
    <div
      className={`flex overflow-hidden rounded-xl bg-${styleSlug}-primary bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary ${textColor} text-center ${
        className || ''
      }`}
      style={{ padding: 2 }}
      {...rest}
    >
      <div
        className={`flex-grow rounded-10 ${bgColor} px-4 ${hasHeader ? 'py-3' : ''} ${
          footer ? '' : 'pb-8'
        }`}
      >
        {hasHeader && (
          <div className="flex items-center justify-between">
            {!!title && (
              <span className={`md:text-lg text-left uppercase ${titleColor}`}>{title}</span>
            )}
            {options}
          </div>
        )}
        <div className={`pt-3 text-3xl md:text-5xl ${bodyColor}`}>{body}</div>
        {footer && <div className="pt-3 text-xs md:text-sm">{footer}</div>}
      </div>
    </div>
  );
};

export default Card;
